import React, { useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/DJ.jpg";
import Toolstack from "./Toolstack";
import Tilt from "react-parallax-tilt";
import { useMouseTracking } from "../../hooks/useMouseTracking";

const rowStyle = { justifyContent: "center", padding: "10px" };

const leftColStyle = {
  justifyContent: "center",
  paddingTop: "30px",
  paddingBottom: "50px",
};

const rightColStyle = {
  paddingTop: "50px",
  paddingBottom: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const headingStyle = {
  fontSize: "2.1em",
  paddingBottom: "20px",
  textAlign: "center",
};

const imageBaseStyle = {
  borderRadius: "50%",
  width: "350px",
  height: "350px",
  objectFit: "cover",
  display: "block",
  outline: "1.7px solid rgba(var(--accent-secondary-rgb), 0.64)",
  boxShadow: "4px 5px 4px 3px rgba(var(--accent-deep-rgb), 0.2)",
};

function TiltImage() {
  const { position, imageRef, containerRef } = useMouseTracking();

  const imageStyle = useMemo(
    () => ({
      ...imageBaseStyle,
      transform: `translate(${position.x * 0.12}px, ${position.y * 0.12}px)`,
    }),
    [position.x, position.y],
  );

  return (
    <Col md={5} ref={containerRef} style={rightColStyle} className="about-img">
      <Tilt>
        <img
          ref={imageRef}
          src={laptopImg}
          alt="about"
          className="img-fluid"
          style={imageStyle}
        />
      </Tilt>
    </Col>
  );
}

function About() {
  return (
    <>
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={rowStyle}>
            <Col md={7} style={leftColStyle}>
              <h1 style={headingStyle}>
                Know Who <strong className="purple">I'M</strong>
              </h1>
              <Aboutcard />
            </Col>
            <TiltImage />
          </Row>
          <h1 className="project-heading">
            Professional <strong className="purple">Skillset </strong>
          </h1>

          <Techstack />

          <h1 className="project-heading">
            <strong className="purple">Tools</strong> I use
          </h1>
          <Toolstack />

          <Github />
        </Container>
      </Container>
    </>
  );
}

export default About;
